// Central place for the site's contact details and navigation.
// Edit the values here – the navbar, footer and enquiry form all read from this file.

export const SCHOOL_NAME = "Agape Garden Play School";

// Web3Forms access key for the enquiry form (https://web3forms.com).
// Preferably set REACT_APP_WEB3FORMS_KEY in a local .env file (see .env.example).
export const WEB3FORMS_ACCESS_KEY =
  process.env.REACT_APP_WEB3FORMS_KEY || "cf2abc04-61f3-402a-bac4-cc4fcf31cbac";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About us", to: "/About" },
  { label: "Features", to: "/Features" },
  { label: "Activities", to: "/Activities" },
  { label: "Testimonial", to: "/Testimonial" },
  { label: "Gallery", to: "/Gallery" },
];

export const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/agapegarden300/",
    icon: "/motion/fb.png",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/agap_egarden/",
    icon: "/motion/insta.png",
  },
];

// One entry per branch – the footer shows a card for each.
// Leave a field as "" to hide it. Rename "Branch 1" / "Branch 2" to the
// locality name (e.g. "Kovilambakkam") if you prefer.
export const BRANCHES = [
  {
    id: "kovilambakkam",
    name: "Branch 1 – Kovilambakkam",

    address:
      "Plot No: 301, 12th Street,\nViduthalai Nagar, S.Kolathur\nKovilambakkam, Chennai - 600 129",

    phone: "96000 58013 / 96000 51683",

    email: "agapegarden300@gmail.com",
  },

  {
    id: "sembakkam",
    name: "Branch 2 – Sembakkam",

    address:
      "Plot No: 13, Door No: 2,\nPTC Colony 4th Street,\nSembakkam, Chennai - 600 073",

    phone: "96000 58013 / 89259 91307",

    email: "agapegardensembakkam@gmail.com",
  },
];